import angular from 'angular'

import emailAsk from './services/ask.service'
import emailResource from './services/resource.service'
import emailMetadata from './services/metadata.service'
import emailRequest from './services/request.service'
import email from './services/email.service'
import myEmailsCreate from './directives/myEmailsCreate'
import myEmailInfo from './directives/myEmailInfo'

import emailLabels from './resources/labels.resource'
import emailFields from './resources/fields.resource'

const name = 'email'
angular.module(name, [])

  .factory('emailAsk', emailAsk)
  .factory('emailResource', emailResource)
  .factory('emailMetadata', emailMetadata)
  .factory('emailRequest', emailRequest)
  .factory('$$email', email)

  .directive('myEmailsCreate', myEmailsCreate)
  .directive('myEmailInfo', myEmailInfo)

  .factory('emailFields', emailFields)
  .factory('emailLabels', emailLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/email.module.js